<template>
  <v-app-bar app>
    <v-toolbar-title>
      <router-link to="/" class="site-title">
        <img :src="brandLogo" alt="Brand Logo" class="brand-logo" />
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    
    <v-btn icon @click="toogleSidebar">
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <!-- <v-menu offset-y>
      <template v-slot:activator="{ props }">
        <v-btn text v-bind="props">
          🌏 {{ selectedLanguageLabel }}
          <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        
        <v-list-item v-for="lang in languages" :key="lang.code" @click="changeLanguage(lang.code, lang.label)">
          <v-list-item-title>{{ lang.label }}</v-list-item-title>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-list-item>
            <v-list-title>
              ID:
              <v-label>
                  {{ userProfile.nickname.substring(0, 6) }}...
              </v-label>
          </v-list-title>
        </v-list-item>
        <v-list-item>   
            <v-list-title @click="copyWalletAddress">
                {{ isUserLoggedIn ? formattedWalletAddress : $t('siteHeader.connectWallet') }}
                <v-icon>mdi-content-copy</v-icon>
            </v-list-title>
        </v-list-item>
        <v-list-item>
            <v-list-title @click="toogleWalletConection">
              {{ isUserLoggedIn ? formattedWalletAddress : $t('siteHeader.connectWallet') }} 
              <v-icon>mdi-logout</v-icon>
            </v-list-title>
        </v-list-item>
      </v-list>
    </v-menu> -->
  </v-app-bar>
</template>

<script>
// import { mapState } from 'vuex';
export default {
  props: {
    isUserLoggedIn: Boolean,
    toggleWalletConnection: Function,
    brandLogo: String,
    walletAddress: String,
  },
  data() {
    return {
      languages: [
        { code: 'zhHant', label: '繁體' },
        { code: 'en', label: 'English' },
        { code: 'ko', label: '한국어' },
      ],
      selectedLanguageLabel: '繁體',
    };
  },
    mounted() {
    if(!this.isUserLoggedIn) {
      this.$router.back();
    }
  },
  methods: {
    toogleSidebar() {
      this.$emit('toogle-sidebar');
    }
  }
  // methods: {
  //   navigateTo(route) {
  //     this.$router.push(route);
  //   },
  //   changeLanguage(lang, label) {
  //     this.selectedLanguageLabel = label;
  //     this.$emit('change-language', lang, label);
  //   },
  //   copyWalletAddress() {
  //     navigator.clipboard.writeText(this.walletAddress).then(() => {
  //       this.$toast.success('Copied to clipboard');
  //     }).catch((error) => {
  //       this.$toast.error('Failed to copy to clipboard'+ error.message);
  //     });
  //   },
  //   toogleWalletConection() {
  //     this.toggleWalletConnection();
  //   },
  // },
};
</script>

<style scoped>
.site-title {
  text-decoration: none;
  color: inherit;
}

.brand-logo {
  height: 40px;
  max-width: 100%;
  object-fit: contain;
}
</style> 